import { render } from "./ViewGeneral.vue?vue&type=template&id=24d0b15c"
import script from "./ViewGeneral.vue?vue&type=script&lang=js"
export * from "./ViewGeneral.vue?vue&type=script&lang=js"

import "./ViewGeneral.vue?vue&type=style&index=0&id=24d0b15c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__